import { useEffect, useRef } from 'react';

export function useThrottle(callback: (...args: unknown[]) => void, delay: number) {
    const callbackRef = useRef(callback);

    useEffect(() => {
        callbackRef.current = callback;
    }, [callback]);

    const throttledFn = useRef(
        throttle((...args) => {
            callbackRef.current?.(...args);
        }, delay),
    );

    return throttledFn.current;
}

function throttle(fn, wait) {
    let timeout;
    let lastCall = 0;

    return (...args) => {
        const now = Date.now();
        const remaining = wait - (now - lastCall);
        clearTimeout(timeout);

        if (remaining <= 0) {
            lastCall = now;
            fn.apply(this, args);
        } else {
            timeout = setTimeout(() => {
                lastCall = Date.now();
                fn.apply(this, args);
            }, remaining);
        }
    };
}
